<template>
  <svg fill="none" height="18" viewBox="0 0 18 18" width="18">
    <path
      d="M9 10C11.2091 10 13 8.20914 13 6C13 3.79086 11.2091 2 9 2C6.79086 2 5 3.79086 5 6C5 8.20914 6.79086 10 9 10Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    />
    <path
      d="M16 17V16.1765C16 15.3028 15.6313 14.5826 14.9749 13.9648C14.3185 13.3471 13.4283 13 12.5 13H5.5C4.57174 13 3.6815 13.3471 3.02513 13.9648C2.36875 14.5826 2 15.3028 2 16.1765V17"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    />
  </svg>
</template>

<script>
  export default {
    name: 'UserIcon',
  };
</script>

